import { render, staticRenderFns } from "./ImprestCashComment.vue?vue&type=template&id=a073ec92&scoped=true"
import script from "./ImprestCashComment.vue?vue&type=script&lang=js"
export * from "./ImprestCashComment.vue?vue&type=script&lang=js"
import style0 from "./ImprestCashComment.vue?vue&type=style&index=0&id=a073ec92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a073ec92",
  null
  
)

export default component.exports